// import { ExportField } from '../../../../utils/exportField';
import { ExportField } from '../../../../utils/exportField';
import { ICustomInspectionTypeSettings } from '../../ICustomInspectionTypeSettings';
import { AoInspectieOverspanningenUnitCode } from './AoInspectieOverspanningenUnitCode';
import { conditionScoreToText, conditionScoreToColorCode } from './conditionScore';
import { GevelbevestigingUnitData } from './unitTypes';

const translationNl = {
    inspectionStandard: {
        aoInspectieOverspanningen: 'Overspanningen Inspectie',
    },
};

// This won't be used in English, so no need to translate it.
const translation = {
    en: translationNl,
    nl: translationNl,
};

function unitInspectionStandardDataToFieldsArray(inspectionStandardData: any, _elementCode: string, unitCode: string) {
    if (!inspectionStandardData) {
        return [];
    }

    const result: ExportField[] = [];
    if (unitCode === AoInspectieOverspanningenUnitCode.Gevelbevestiging) {
        const data = inspectionStandardData as GevelbevestigingUnitData;
        result.push({
            name: 'belemmerendeBelastendeBegroeiingBijOverspanningsinstallatie',
            value: data.belemmerendeBelastendeBegroeiingBijOverspanningsinstallatie,
            dataType: 'boolean',
        });
    }

    // result.push({ name: 'field1', value: inspectionStandardData?.field1, dataType: 'string' });
    // result.push({ name: 'field2', value: inspectionStandardData?.field2, dataType: 'string' });
    // result.push({ name: 'field3', value: inspectionStandardData?.field3, dataType: 'string' });
    // result.push({ name: 'field4', value: inspectionStandardData?.field4, dataType: 'string' });

    return result;
}

export const aoInspectieOverspanningen: ICustomInspectionTypeSettings = {
    inspectionStandardType: 'aoInspectieOverspanningen',
    translation,
    conditionScoreToColorCode,
    unitInspectionStandardDataToFieldsArray,
    conditionScoreToText: (conditionScore: number | undefined | null | string, _translate: (key: string) => string) =>
        conditionScoreToText(conditionScore as any),
};
